import { render, staticRenderFns } from "./SalesConsignmentReport.vue?vue&type=template&id=05dcd37b"
import script from "./SalesConsignmentReport.vue?vue&type=script&lang=js"
export * from "./SalesConsignmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports